<template>
    <div class="faqs">
        <b-container fluid >
            <div class="row">           
                <b-col cols="12" md="4" class="mycontainer-main m-borders">
                    <div class="row h-100 ml-5">
                        <div class="col-sm-12 align-self-center text-left">
                            <div>
                                <h1  >{{ $t('faqs.jumbo-title') }}</h1>
                                <h1 class="pageSubtitle">/ {{ $t('faqs.jumbo-message') }}</h1>
                                <b-button squared variant="outline-dark" class="mt-3 shadow"  @click="goBack"> {{ $t('common.goback') }}</b-button>                               
                            </div>
                        </div>
                    </div>
                
                </b-col>
            
                <b-col cols="12" md="8">
                        <b-row class="h-100 py-5">
                            <b-col cols="12" class="col-sm-8 py-1" v-for="f in faqs" :key="f.id">
                            <b-button 
                            v-b-toggle=f.name 
                            squared variant="outline-dark" 
                            style="min-width: 100%;" 
                            class="text-left">
                            {{f.name}} 
                            </b-button>
                                <b-collapse v-bind:id="f.name" class="mt-2"> 
                                    <div class="row">
                                        <div class="col-sm-12 py-2 "> 
                                            <p>{{f.answer}}</p>
                                        </div>
                                    </div>
                                </b-collapse>
                            </b-col>
                        </b-row>
                </b-col>
            </div>
        </b-container>
    </div>
</template>

<script>

const enData = [
    {name: "How fast can you ship products",
    answer: "The products that we have on inventory are usually sent the same day. Depending on the carrier, it can take 2 to 3 business days to get to you in the Province of Québec. If we don’t have your product in inventory at the time, you can count add 2 to 3 more days to recieve your products.",
    },
    {name: "Are the BBL treatments painful?",
    answer: " The treatments are comfortable although there may be some slight sensations of heat in the most sensitive places. The aesthetician who will do your treatment will ensure your comfort throughout the treatment."
    },
    {name: "What is the difference between regular electrolysis and electrolysis by microcurrents?",
    answer: " Regular electrolysis is only provided with 2 currents. Including a thermolysis current and a galvanic current with a frequency of 5 MHz or 13.56 MHz. The new micro current electrolysis machine uses the ULTRA-FAST radio frequency of 27.12 MHz so its power is 6 times faster than the other machines. This new GENERATION allows you to concentrate the energy more intensely at the base of the hair and thus obtain FINAL results much more quickly on all types of hair. It offers SIX hair removal modes and an unequaled level of COMFORT in permanent hair removal.These EXCLUSIVE techniques combined with new programs specially OPTIMIZED for MEN and women by choosing what is most effective depending on the area treated, the size of the hair and the appropriate filament which are allies for the effectiveness of the treatment done. In addition, this new generation can also offer adapted treatments to the electrologist with an automatic program for the performance of treatments depending on the currents and hydration of the region in order to provide SUPERIOR EFFICIENCY and more comfort.",
    },
    {name: "What is the process of an online consultation with an esthetician? ",
    answer: "You will be asked to complete a questionnaire before your meeting. Our team will send you all the preparation instructions before your appointment. Thereafter, the esthetician will tour your current habits with you as well as your lifestyle. She wishes you to make the choice in your current products, use your current products and make some modifications or additions to optimize your routine according to your concerns. Our team will send you a checklist of your new routine and your choices of new products will be sent directly to your home.",
    }
]

const frData = [
    {name: "Combien celà prend-t’il de temps pour recevoir mes produits à la maison après avoir passsé une commande?",
    answer: "Les produits en inventaire sont normalement envoyé la journée même, tout dépendant du fournisseur de livraison, la livraison peut prendre 2 à 3 journées ouvrables pour la Province de Québec. Si nous n’avons pas votre produit en main, il faut compter 2 à 3 journées supplémentaires.",
    },
    {name: "Est-ce que les traitements de BBL (Épiltion définitive) sont douloureux?",
    answer: "Les traitments sont confortables malgré qu’il peut y avoir quelques légères sensations de chaleur dans les endroits plus sensibles. L’esthéticienne qui fera votre traitement s’assurera de votre confort tout au long du traitement."
    },
    {name: "Quelle est la différence entre l’électrolyse régulière et l’électrolyse à micro-courants?",
    answer: " L'électrolyse régulière n'est fournie qu'avec 2 courants. Un courant de thermolyse et un courant galvanique avec une fréquence de 5 MHz ou 13,56 MHz. La nouvelle machine d'électrolyse à micro-courant utilise la fréquence radio ULTRA-FAST de 27,12 MHz, donc sa puissance est 6 fois plus rapide que les autres machines. Cette nouvelle GÉNÉRATION vous permet de concentrer l'énergie plus intensément à la base du cheveu et ainsi d'obtenir des résultats FINAUX beaucoup plus rapidement sur tous types de cheveux. Il offre SIX modes d'épilation et un niveau de CONFORT inégalé dans l'épilation permanente. Ces techniques EXCLUSIVES associées à de nouveaux programmes spécialement OPTIMISÉS POUR HOMMES et femmes en choisissant ce qui est le plus efficace en fonction de la zone traitée, de la taille des cheveux et du filament approprié qui sont des alliés pour l'efficacité du traitement effectué. De plus, cette nouvelle génération peut également proposer des traitements adaptés à l'électrologiste avec un programme automatique pour la réalisation de traitements en fonction des courants et de l'hydratation de la région afin d'offrir une EFFICACITÉ SUPÉRIEURE et plus de confort.",
    },
    {name: "Comment se déroule une consultation virtuelle?",
    answer: "Vous serez invité à remplir un questionnaire avant votre rencontre. Notre équipe vous enverra toutes les instructions de préparation avant votre rendez-vous. Par la suite, l’esthéticienne fera une tournée de vos habitudes actuelles avec vous ainsi que de votre mode de vie. Elle vous aidera à faire le choix dans vos produits actuels, utiliser vos produits actuels et faire quelques modifications ou ajouts pour optimiser votre routine en fonction de vos préoccupations. Notre équipe se chargera de vous transmettre un document aide-mémoire de votre nouvelle routine et vos choix de nouveaux produits seront envoyés directement à votre domicile."
    },
]


export default {
    name: 'faqs',
    data () {
        return {
            faqs: ''
    }
  },
  methods: {
  goBack(){
    this.$router.go(-1)
  },
  getData () {
        if (this.$i18n.locale == 'fr'){
          this.faqs = frData;
        }
        else this.faqs = enData
         }
  },
  computed: {
      locale(){
          return this.$i18n.locale
      },
  },
  mounted() { 
      this.getData()   
  },
    watch: {
      locale: function (newLocale, oldLocale) {
        this.getData()
      }
    },
}

</script>

<style scoped>
.mycontainer-main {
    height:  calc(75vh);
}
</style>




// WEBPACK FOOTER //
// src/pages/Faqs.vue